import React from 'react';
import { TabData } from 'shared/types/common.interface';
import { MY_MENU } from 'shared/constants/menu-constants';
import { urls } from 'shared/constants/routing.constants';
import MyDebates from 'pages/Main/MyDebates/MyDebates';
import MyChallenges from 'pages/Main/MyChallenges/MyChallenges';
import Profile from 'pages/Main/Profile/Profile';
import TabsComponent from 'components/Tabs/TabsComponent/TabsComponent';
import PageContainer from 'pages/PageContainer';
import { useAuth } from 'shared/guards/useAuth';

export const Account: React.FunctionComponent<any> = () => {
  useAuth();
  const PROFILE_TABS_COMPONENTS: TabData[] = [
    {
      label: MY_MENU.MyChallenges,
      component: <MyChallenges />,
      path: urls.myPages.myChallenges,
    },
    {
      label: MY_MENU.MyDebates,
      component: <MyDebates />,
      path: urls.myPages.myDebates,
    },
    {
      label: MY_MENU.Profile,
      component: <Profile />,
      path: urls.myPages.profile,
    },
  ];

  return (
    <PageContainer>
      <TabsComponent components={PROFILE_TABS_COMPONENTS} className="profileTabs" />
    </PageContainer>
  );
};

export default Account;
